export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "nl": {
        "locale": {
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nederlands"])}
        }
      },
      "fr": {
        "locale": {
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Français"])}
        }
      },
      "de": {
        "locale": {
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deutsch"])}
        }
      },
      "da": {
        "locale": {
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dansk"])}
        }
      },
      "en": {
        "locale": {
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["English"])}
        }
      }
    }
  })
}